// @ts-nocheck
import { verifyEmail } from '../auth/session';
import { showToast } from '../components/toast/toast';
import { t } from '../i18n';
import { translateApiError } from '../i18n/api-errors';

export function getVerifyTokenFromUrl(params?: URLSearchParams): string | null {
  const search = params ?? new URLSearchParams(window.location.search);
  const token = search.get('verify_token')?.trim();
  return token || null;
}

export function clearVerifyTokenFromUrl(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('verify_token')) return;
  url.searchParams.delete('verify_token');
  const next = url.pathname + (url.search ? url.search : '') + url.hash;
  window.history.replaceState({}, '', next);
}

export function initVerifyEmailDeepLink(): void {
  const token = getVerifyTokenFromUrl();
  if (!token) return;

  verifyEmail(token)
    .then(() => {
      clearVerifyTokenFromUrl();
      showToast(t('auth.verifySuccess'), 'success', 5000);
    })
    .catch((err) => {
      clearVerifyTokenFromUrl();
      showToast(translateApiError(err) || t('auth.verifyFailed'));
    });
}
